import {
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	MagnifyingGlassIcon,
} from "@heroicons/react/20/solid";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Actions as ADVISORACTIONS } from "../../store/actions/advisorActions";
import { Actions as COMPANYACTIONS } from "../../store/actions/companyActions";
import { Actions as ADMINACTIONS } from "../../store/actions/adminActions";
import BillingEmailRow from "./BillingEmailRow";
import BillingFilters from "@/components/admin/BillingFilters";

const BillingEmails = ({
	getAdvisorBillingEmails,
	getCompanyBillingEmails,
	getAdminBillingEmails,
	billingEmailsList,
	companyBillingEmailsList,
	adminBillingEmailsList,
	forAdvisor,
	permission,
	forAdmin,
}) => {
	const [search, setSearch] = useState("");
	const [filteredBillingEmailsList, setFilteredBillingEmailsList] = useState([]);
	useMemo(() => {
		const filterByValue = (o) =>
			["email", "date", "attempt", "billingId"].some((k) =>
				String(o[k])?.toLowerCase().includes(search.toLowerCase()),
			);

		if (forAdvisor) {
			setFilteredBillingEmailsList(
				search.replace(/\s/g, "") ? billingEmailsList?.filter(filterByValue) : billingEmailsList,
			);
		} else if (forAdmin) {
			setFilteredBillingEmailsList(
				search.replace(/\s/g, "") ? adminBillingEmailsList?.filter(filterByValue) : adminBillingEmailsList,
			);
		} else {
			setFilteredBillingEmailsList(
				search.replace(/\s/g, "") ? companyBillingEmailsList?.filter(filterByValue) : companyBillingEmailsList,
			);
		}
	}, [search, billingEmailsList, companyBillingEmailsList, adminBillingEmailsList]);

	const [itemsPerPage, setItemsPerPage] = useState(20);
	const [page, setPage] = useState(0);
	const start = page * itemsPerPage;
	const end = (page + 1) * itemsPerPage;

	useEffect(() => {
		if (forAdvisor) {
			getAdvisorBillingEmails();
		} else if (forAdmin) {
			getAdminBillingEmails();
		} else {
			getCompanyBillingEmails();
		}
	}, []);
	const lastPage = Math.ceil(filteredBillingEmailsList?.length / itemsPerPage) || 1;
	const Pagination = () => {
		if (filteredBillingEmailsList?.length <= 0) return null;
		return (
			<thead>
				<tr>
					<th colSpan={6}>
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go To Page 1"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(0);
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 5 Pages"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(Math.max(page - 5, 0));
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 1 Page"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(page - 1);
									}}
									disabled={page === 0}
								>
									<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<strong>
									Page {page + 1}/{lastPage}
								</strong>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title={`Go to Page ${lastPage}`}
									onClick={() => {
										if (page !== lastPage - 1) setPage(lastPage - 1);
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title="Go Forward 5 Pages"
									onClick={() => {
										if (page !== lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									title="Go Forward 1 Page"
									onClick={() => {
										if (page !== lastPage - 1) setPage(page + 1);
									}}
									style={{ marginRight: "0.5rem" }}
									disabled={page === lastPage - 1}
								>
									<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
						</div>
					</th>
				</tr>
			</thead>
		);
	};

	if (permission === "None") return null;

	return (
		<>
			<div className="clearfix" />
			<div
				className="content"
				style={{ overflow: "auto" }}
			>
				{forAdmin && (
					<BillingFilters
						billingEmails={filteredBillingEmailsList}
						setBillingEmails={setFilteredBillingEmailsList}
						unfilteredEmails={adminBillingEmailsList}
					/>
				)}

				<div className="block-header">
					<h3 className="block-title">Billing Emails</h3>
				</div>
				<div className="block-content">
					<div
						style={{
							border: "1px solid #bbbcbc",
							borderBottom: "none",
							position: "relative",
						}}
					>
						<MagnifyingGlassIcon
							className={"text-gray"}
							style={{
								height: "1.5em",
								position: "absolute",
								margin: "0.75em",
							}}
						></MagnifyingGlassIcon>
						<input
							name="search"
							onChange={(e) => setSearch(e.target.value)}
							value={search}
							placeholder="Search"
							autoComplete="off"
							style={{
								border: "none",
								display: "inline-block",
								maxWidth: "100%",
								width: "100%",
								padding: 10,
								paddingLeft: 40,
							}}
						/>
					</div>{" "}
					<table
						id="table-timesheets"
						className="table-responsive table table-hover"
					>
						<Pagination />
						<thead>
							<tr>
								<th style={{ textAlign: "center" }}>Billing Email</th>
								<th style={{ textAlign: "center" }}>Date</th>
								<th style={{ textAlign: "center" }}>Attempt</th>
								<th width="5%" />
							</tr>
						</thead>
						<tbody>
							{filteredBillingEmailsList?.length > 0 ? (
								filteredBillingEmailsList?.slice(start, end)?.map((email) => (
									<BillingEmailRow
										key={email.id}
										email={email}
									/>
								))
							) : (
								<tr>
									<th colSpan={4}>No Emails{search ? ` matching "${search}"` : null}.</th>
								</tr>
							)}
						</tbody>
						<Pagination />
					</table>
					<div className="clearfix" />
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state, { forAdvisor }) => {
	return {
		permission: forAdvisor ? true : state?.permissions?.my?.permissions?.billing,
		billingEmailsList: state?.advisors?.billingEmails?.emails,
		companyBillingEmailsList: state?.company?.billingEmails?.emails,
		adminBillingEmailsList: state?.admin?.billingEmails,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAdvisorBillingEmails: () => dispatch(ADVISORACTIONS.getBillingEmails()),
	getCompanyBillingEmails: () => dispatch(COMPANYACTIONS.getBillingEmails()),
	getAdminBillingEmails: () => dispatch(ADMINACTIONS.getBillingEmails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BillingEmails);
